'use client';

import { c as _c } from "react/compiler-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import type { Product } from '@libs/common-types';
import { resolveFulfillmentMethod } from '../../product-details';
import { miniPdpFormSchema } from '../schema';
import type { MiniPdpForm } from '../types';
const getDefaultValues = (product?: Product, selectedSku = ''): MiniPdpForm => {
  const availableMethods = {
    bopis: Boolean(product?.deliveryMethods.BOPIS.availablePurchaseOptions.oneTime),
    sdd: Boolean(product?.deliveryMethods.SDD.availablePurchaseOptions.oneTime),
    sth: Boolean(product?.deliveryMethods.STH.availablePurchaseOptions.oneTime)
  };
  const fulfilmentMethod = resolveFulfillmentMethod({
    availableMethods
  });
  const method = fulfilmentMethod.toUpperCase() as keyof Product['deliveryMethods'];
  return {
    selectedSku,
    fulfilmentMethod,
    quantity: product?.deliveryMethods[method].purchaseQuantities?.min ?? 1
  };
};
export const useMiniPdpForm = (product, t0) => {
  const $ = _c(11);
  const selectedSku = t0 === undefined ? "" : t0;
  let t1;
  if ($[0] !== product || $[1] !== selectedSku) {
    t1 = getDefaultValues(product, selectedSku);
    $[0] = product;
    $[1] = selectedSku;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = zodResolver(miniPdpFormSchema);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = {
      defaultValues: t1,
      resolver: t2
    };
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const form = useForm(t3);
  let t4;
  let t5;
  if ($[6] !== form || $[7] !== product || $[8] !== selectedSku) {
    t4 = () => {
      form.reset(getDefaultValues(product, selectedSku));
      form.trigger();
    };
    t5 = [form, product, selectedSku];
    $[6] = form;
    $[7] = product;
    $[8] = selectedSku;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  return form;
};